
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"29","height":"29","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"14.5","cy":"14.5","r":"14.5","fill":"#176FA9"}}),_c('rect',{attrs:{"x":"8.5","y":"8.5","width":"5.006","height":"5.006","rx":".5","fill":"#fff","stroke":"#fff"}}),_c('rect',{attrs:{"x":"15.707","y":"8.5","width":"5.006","height":"5.006","rx":".5","fill":"#fff","stroke":"#fff"}}),_c('rect',{attrs:{"x":"8.5","y":"15.707","width":"5.006","height":"5.006","rx":".5","fill":"#fff","stroke":"#fff"}}),_c('rect',{attrs:{"x":"15.707","y":"15.707","width":"5.006","height":"5.006","rx":".5","fill":"#fff","stroke":"#fff"}})])
          )
        }
      }
    